export function getBaseUrl(): string {
  return process.env.PUBLIC_URL || process.env.NEXT_PUBLIC_URL || 'https://childrenswi.org';
}

export function getPageUrl(currentPath: string) {
  return `${getBaseUrl()}${currentPath}`;
}
